import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'centers',
  initialState: {
    data: {
      resume: {
        active_students: 0,
        active_teachers: 0,
        registered_students: 0,
        registered_teachers: 0,
        total_classes: 0,
        total_students_usage_time: 0,
        total_teachers_usage_time: 0,
        total_centers: 0,
      },
      centers: [],
    },
  },
  reducers: {
    setCenters: (state, { payload: obj }) => {
      state.data = obj;
    },
  },
});

export const { setCenters } = slice.actions;

export default slice.reducer;

export const selectCenters = (state) => state.centers.data;
